import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from '../../../common/AdviserProfiles/AdviserProfilePictures/_AdviserProfilePictures.scss'
import defaultProfileImage from '../../../images/default-profile-picture.png'
import defaultCompanyImage from '../../../images/default-company-logo.png'
import EditButton from '../../../common/forms/EditButton'
import { connect } from 'react-redux'
import { actions } from './adviserProfilePicturesEditorActions'
import { Row, Col, Modal } from 'react-bootstrap'
import ImageEditor from '../../../common/ImageEditor'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';

class AdviserProfilePicturesEditor extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    editingProfilePicture: PropTypes.bool.isRequired,
    editingCompanyPicture: PropTypes.bool.isRequired,
    profilePicture: PropTypes.string,
    companyLogo: PropTypes.string,
    startEditingProfilePicture: PropTypes.func.isRequired,
    stopEditingProfilePicture: PropTypes.func.isRequired,
    cancelEditingProfilePicture: PropTypes.func.isRequired,
    indicateProfilePictureUploading: PropTypes.func,
    indicateProfilePictureUploadCompleted: PropTypes.func,
    uploadingProfilePicture: PropTypes.bool.isRequired,
    setProfilePicture: PropTypes.func.isRequired,
    profilePictureIsValid: PropTypes.bool.isRequired,
    submittingProfilePicture: PropTypes.bool.isRequired,
    editingPictures: PropTypes.bool.isRequired,
    startEditingCompanyPicture: PropTypes.func.isRequired,
    stopEditingCompanyPicture: PropTypes.func.isRequired,
    cancelEditingCompanyPicture: PropTypes.func.isRequired,
    indicateCompanyPictureUploading: PropTypes.func,
    indicateCompanyPictureUploadCompleted: PropTypes.func,
    uploadingCompanyPicture: PropTypes.bool,
    setCompanyPicture: PropTypes.func.isRequired,
    companyPictureIsValid: PropTypes.bool,
    submittingcompanyPicture: PropTypes.bool,
    editingProfile: PropTypes.bool.isRequired
  };

  get defaultAvatarScale () { return 1 }
  constructor (props) {
    super(props)
    this.state = {
      profilePictureEditorRef: null,
      companyLogoEditorref: null,
      avatarScale: this.defaultAvatarScale,
      companyLogoscale: 1.2,
      avatarInputRef: null,
      avatarEditorModalIsOpen: false
    }

    this.renderProfilePicture = this.renderProfilePicture.bind(this)
    this.stopEditingProfilePicture = this.stopEditingProfilePicture.bind(this)
    this.renderCompanyLogo = this.renderCompanyLogo.bind(this)
    this.stopEditingCompanyPicture = this.stopEditingCompanyPicture.bind(this)
  }

  stopEditingProfilePicture (imageDataUrl) {
    this.props.setProfilePicture(imageDataUrl)
    this.props.stopEditingProfilePicture()
  }

  stopEditingCompanyPicture (imageDataUrl) {
    this.props.setCompanyPicture(imageDataUrl)
    this.props.stopEditingCompanyPicture()
  }

  renderProfilePicture () {
    const defaultProfilePicture = <img src={defaultProfileImage} />
    const profilePicture = this.props.profilePicture ? <img src={this.props.profilePicture} /> : defaultProfilePicture

    return <Col xs={6} sm={6} md={6} lg={6} className={styles['profile-image'] + ' ' + styles['editor-pic']}>
      {profilePicture}
      <Modal size='lg' show={this.props.editingProfilePicture} aria-labelledby='contained-modal-title' >
        <Modal.Body>
          <ImageEditor
            imageTitle='Profile Image'
            handleFileChange={(imageDataUrl) => {
              this.props.setProfilePicture(imageDataUrl)
            }}
            image={this.props.profilePicture}
            isOpen={this.props.editingProfilePicture}
            stopEditing={this.stopEditingProfilePicture}
            cancelEditing={() => {
              this.setState({ avatarScale: this.defaultAvatarScale })
              this.props.cancelEditingProfilePicture()
            }} />
        </Modal.Body>
      </Modal>
      <div className={styles['edit-button-offset']}>
        { this.props.editingPictures && this.props.editingProfile && <EditButton
          submitting={false}
          editing={false}
          startEditing={() => { this.props.startEditingProfilePicture() }} /> }
      </div>
    </Col>
  }

  renderCompanyLogo () {
    const defaultCompanyLogo = <img src={defaultCompanyImage} />
    return <Col xs={6} sm={6} md={6} lg={6} className={styles['company-profile-image'] + ' ' + styles['editor-pic']}>
      { this.props.companyLogo
        ? <img src={this.props.companyLogo} />
        : defaultCompanyLogo
      }
      <Modal
        size='lg'
        show={this.props.editingCompanyPicture}
        aria-labelledby='contained-modal-title' >
        <Modal.Body>
          <ImageEditor
            handleFileChange={(imageDataUrl) => {
              this.props.setCompanyPicture(imageDataUrl)
            }}
            imageTitle='Company Logo'
            image={this.props.companyLogo}
            isOpen={this.props.editingCompanyPicture}
            stopEditing={this.stopEditingCompanyPicture}
            cancelEditing={() => {
              this.setState({ avatarScale: this.defaultAvatarScale })
              this.props.cancelEditingCompanyPicture()
            }} />
        </Modal.Body>
      </Modal>
      <div className={styles['edit-button-offset']}>
        { this.props.editingPictures && this.props.editingProfile &&
        <EditButton
          submitting={false}
          editing={false}
          startEditing={() => { this.props.startEditingCompanyPicture() }} /> }
      </div>
    </Col>
  }

  render () {
    return <Row>
      { this.renderProfilePicture() }
      { this.renderCompanyLogo() }
    </Row>
  }
}

const mapStateToProps = ({adviserProfileEditorContainer}) => {
  return {
    editingProfilePicture: adviserProfileEditorContainer.profilePictures.editingProfilePicture,
    uploadingProfilePicture: adviserProfileEditorContainer.profilePictures.uploadingProfilePicture,
    submittingProfilePicture: adviserProfileEditorContainer.profilePictures.submittingProfilePicture,
    profilePictureIsValid: adviserProfileEditorContainer.profilePictures.profilePictureIsValid,
    editingCompanyPicture: adviserProfileEditorContainer.profilePictures.editingCompanyLogo,
    uploadingCompanyPicture: adviserProfileEditorContainer.profilePictures.uploadingCompanyPicture,
    submittingCompanyPicture: adviserProfileEditorContainer.profilePictures.submittingCompanyPicture,
    companyPictureIsValid: adviserProfileEditorContainer.profilePictures.companyPictureIsValid,
    editingPictures: adviserProfileEditorContainer.profilePictures.editingPictures,
    editingProfile: adviserProfileEditorContainer.editingProfile
  }
}

const mapDispatchToProps = (dispatch) => {
  const { upload, set, edit } = actions
  return bindActionCreators({
    startEditingProfilePicture: edit.profilePic.start,
    stopEditingProfilePicture: edit.profilePic.stop,
    cancelEditingProfilePicture: edit.profilePic.cancel,
    setProfilePicture: set.profilePic,
    indicateProfilePictureUploading: upload.profilePic.uploading,
    indicateProfilePictureUploadCompleted: upload.profilePic.uploaded,
    startEditingCompanyPicture: edit.companyPic.start,
    stopEditingCompanyPicture: edit.companyPic.stop,
    cancelEditingCompanyPicture: edit.companyPic.cancel,
    setCompanyPicture: set.companyPic,
    companyPictureUploaded: upload.companyPic.uploaded
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (AdviserProfilePicturesEditor))
